// extracted by mini-css-extract-plugin
module.exports = {"container":"Phase_container__2u9cr","title":"Phase_title__3Jn7b","text":"Phase_text__2z8mt"};